import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, X, ZoomIn } from 'lucide-react';
export const MenuSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const menuImages = [{
    id: 1,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nYRNKR91nr7VQoBxXUUzSN/001_PORTADA.png',
    title: 'Nuestra Carta'
  }, {
    id: 2,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gijoKZhS9d1BPeRUm1rZfU/002_FOTO.png',
    title: 'Especialidades'
  }, {
    id: 3,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o6aAxneeWLGC7PSkZBrtwP/003_ENTRADAS_Y_TACOS.png',
    title: 'Entradas y Tacos'
  }, {
    id: 4,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qJxHNAghtAjxHhshKWC5Cs/004_LIBERA_AL_KRAKEN.png',
    title: 'Libera al Kraken'
  }, {
    id: 5,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wuQP4nvnQ5iyVyTwFhf4AH/005_FOTO.png',
    title: 'Nuestros Cortes'
  }, {
    id: 6,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fi8Xndn5wmTKxVhq2YN3Po/006_CORTES_PREMIUM.png',
    title: 'Cortes Premium'
  }, {
    id: 7,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o1jNQ5ZzaQArswgqvCMUyD/007_COMPARTE_EL_BOTIN_PARRILLADAS.png',
    title: 'Comparte el Botín'
  }, {
    id: 8,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/omBLtxvM8z5Rp3CJRGyyNY/008_LA_EPOPEYA_ITALIANA.png',
    title: 'La Epopeya Italiana'
  }, {
    id: 9,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/myVvdCL1PEwwC1bbtCABgG/009_PASTAS.png',
    title: 'Pastas'
  }, {
    id: 10,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dbgi4ifxatH2ZWBK5Y7i3z/010_CURSO_AL_CARIBE.png',
    title: 'Curso al Caribe'
  }, {
    id: 11,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iuNjTwhDutFWG5mtANSm5Q/011_POSTRES.png',
    title: 'Postres'
  }, {
    id: 12,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kyVgmtA7o7BxAeHLzorPRC/012_GUARNICIONES.png',
    title: 'Guarniciones'
  }, {
    id: 13,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aJ88N7jatgTH176ZAgy1FU/013_BEBIDAS.png',
    title: 'Bebidas'
  }, {
    id: 14,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vuWuehZDGLeWFcn3fdzzrZ/014_PORTADA.png',
    title: 'La Taberna de Jack'
  }, {
    id: 15,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/faLuPiZZTe8ZYHbAnsRF69/015_FOTO.png',
    title: 'Nuestras Bebidas'
  }, {
    id: 16,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cG5fTStg6xCQfABVuBoPEX/016_PREPARADAS_SODAS_Y_CERVEZAS.png',
    title: 'Preparadas y Cervezas'
  }, {
    id: 17,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gjwwESEuy3PqA1Lahy6M8s/017_VINOS_Y_TEQUILAS.png',
    title: 'Vinos y Tequilas'
  }, {
    id: 18,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1Zv9crUSaJHn7V4QD8H9Gu/018_FOTOS.png',
    title: 'Galería'
  }, {
    id: 19,
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kruWnCQ7aF37ZkifPbCfyW/019_LICORES.png',
    title: 'Licores Premium'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % menuImages.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + menuImages.length) % menuImages.length);
  };
  const openImage = (url: string) => {
    setSelectedImage(url);
  };
  const closeImage = () => {
    setSelectedImage(null);
  };
  return <section id="menu" className="py-20 px-4 bg-pirate-black relative" data-id="element-104">
      <div className="container mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-106">
          <h2 className="font-pirata text-4xl md:text-5xl mb-4" data-id="element-107">
            Nuestro Menú
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-108">
            Descubre los tesoros culinarios del Perla Negra. Haz clic en cada
            imagen para explorar nuestro menú completo.
          </p>
        </motion.div>
        <div className="relative max-w-5xl mx-auto" data-id="element-109">
          <div className="relative h-[600px] md:h-[700px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-110">
            <AnimatePresence mode="wait" data-id="element-111">
              <motion.div key={currentSlide} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.5
            }} className="absolute inset-0 cursor-pointer group" onClick={() => openImage(menuImages[currentSlide].url)} data-id="element-112">
                <img src={menuImages[currentSlide].url} alt={menuImages[currentSlide].title} className="w-full h-full object-contain bg-pirate-black" data-id="element-113" />
                <div className="absolute inset-0 bg-pirate-black/0 group-hover:bg-pirate-black/30 transition-all duration-300 flex items-center justify-center" data-id="element-114">
                  <motion.div initial={{
                  opacity: 0,
                  scale: 0.8
                }} whileHover={{
                  opacity: 1,
                  scale: 1
                }} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-115">
                    <div className="bg-pirate-red/90 backdrop-blur-sm p-4 rounded-full" data-id="element-116">
                      <ZoomIn size={32} className="text-white" data-id="element-117" />
                    </div>
                  </motion.div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-pirate-black via-pirate-black/80 to-transparent p-6" data-id="element-118">
                  <h3 className="font-pirata text-2xl md:text-3xl text-center" data-id="element-119">
                    {menuImages[currentSlide].title}
                  </h3>
                </div>
              </motion.div>
            </AnimatePresence>
            <div className="absolute top-1/2 left-0 right-0 -translate-y-1/2 flex justify-between px-4 z-10" data-id="element-120">
              <motion.button whileHover={{
              scale: 1.1,
              x: -5
            }} whileTap={{
              scale: 0.9
            }} onClick={prevSlide} className="bg-pirate-black/70 backdrop-blur-sm p-3 md:p-4 rounded-full hover:bg-pirate-red/80 transition-all focus:outline-none focus:ring-2 focus:ring-white" aria-label="Previous menu page" data-id="element-121">
                <ChevronLeft className="text-white" size={28} data-id="element-122" />
              </motion.button>
              <motion.button whileHover={{
              scale: 1.1,
              x: 5
            }} whileTap={{
              scale: 0.9
            }} onClick={nextSlide} className="bg-pirate-black/70 backdrop-blur-sm p-3 md:p-4 rounded-full hover:bg-pirate-red/80 transition-all focus:outline-none focus:ring-2 focus:ring-white" aria-label="Next menu page" data-id="element-123">
                <ChevronRight className="text-white" size={28} data-id="element-124" />
              </motion.button>
            </div>
          </div>
          <div className="flex justify-center mt-6 space-x-3" data-id="element-125">
            {menuImages.map((_, index) => <motion.button key={index} onClick={() => setCurrentSlide(index)} whileHover={{
            scale: 1.2
          }} whileTap={{
            scale: 0.9
          }} className={`h-3 rounded-full transition-all focus:outline-none ${currentSlide === index ? 'bg-pirate-red w-12' : 'bg-white/40 w-3 hover:bg-white/60'}`} aria-label={`Go to menu page ${index + 1}`} data-id="element-126" />)}
          </div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-center mt-8" data-id="element-127">
            <p className="text-gray-400 flex items-center justify-center space-x-2" data-id="element-128">
              <ZoomIn size={20} data-id="element-129" />
              <span data-id="element-130">Haz clic en la imagen para verla en tamaño completo</span>
            </p>
          </motion.div>
        </div>
      </div>
      <AnimatePresence data-id="element-131">
        {selectedImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-pirate-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={closeImage} data-id="element-132">
            <motion.button initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} onClick={closeImage} className="absolute top-6 right-6 bg-pirate-red/80 backdrop-blur-sm p-3 rounded-full hover:bg-pirate-red transition-all focus:outline-none focus:ring-2 focus:ring-white z-10" aria-label="Close menu" data-id="element-133">
              <X className="text-white" size={28} data-id="element-134" />
            </motion.button>
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25
        }} className="max-w-6xl max-h-[90vh] w-full" onClick={e => e.stopPropagation()} data-id="element-135">
              <img src={selectedImage} alt="Menu completo" className="w-full h-full object-contain rounded-lg shadow-2xl" data-id="element-136" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
};